
<button  class="ml-2 border rounded px-3 py-1 shadow-sm shadow-sky-500">
  <svg xmlns="http://www.w3.org/2000/svg" (click)="modalreload=true" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </svg>
</button>
<div *ngIf="modalreload"class="modal-component-container fixed inset-0 overflow-y-auto" style="z-index: 1000;">
  <div class="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>

    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

    <div class="modal-container inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
      <div class="modal-wrapper bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="modal-wrapper-flex sm:flex sm:items-start">
          <div class="modal-content mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">
            <span class="pl-2 text-slate-950" style="color: black;">Es posible que algunos elementos se pierdan durante la recarga, asegurate de haber guardado todos los cambios.<br>
            <b>Es importante no tener notificaciones de Devolución, Rollo, Morralla, Retiro activas. En caso de tener alguna de ellas es indispensable finalizar su proceso.</b><br>
            ¿Deseas continuar con esta operación?
            </span>
          </div>
        </div>
      </div>

      <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">

        <button (click)="reloadPage()"
        class="w-full inline-flex justify-center bg-blue-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Recargar
        </button>
        <button (click)="modalreload=false"
        class="w-full inline-flex justify-center bg-red-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Cancelar
        </button>
      </div>

    </div>
  </div>
</div>
